import React from 'react'
import styled from 'styled-components';
import { useStateValue } from '../../State/StateProvider';

const SoftwareProduct = ({ item }) => {
    const [state, dispatch] = useStateValue();
    const addTobasket = () => {
        //dispatch the item into the data layer
        dispatch({
            type: "ADD_TO_BASKET",
            item: {
                id: item.id,
                name: item.name,
                image: item.image,
                price: item.price,
            },
        });
    };

    return (
        <StyledDiv>
            <div className="image">
                <img src={item.image} alt="img" />
            </div>
            <div className="name">
                <h4>{item.name}</h4>
            </div>
            <div className="price">
                <p>₹{item.price}</p>
            </div>
            <button onClick={addTobasket}>Add To Cart</button>
        </StyledDiv>
    )
}

export default SoftwareProduct


const StyledDiv = styled.div`
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    height: 27rem;
    width: 18rem;
    box-shadow: 0 0 20px 3px rgb(0 0 0 / 10%);
    margin: 0rem 1rem;
    padding: 0rem 1rem;
    color: #000219;
    .image{
        width: 100%;
        height: 15rem;
        margin-bottom: 0.5rem;
        /* background-color: red; */
        img{
            width: 100%;
            height: 100%;
            object-fit: contain;
            margin-bottom: 0.5rem
        }
    }
    .name{
        /* height: 3rem; */
        /* background-color: red; */
    }
    .price{
        /* background-color: pink;  */
    }
    h4{
        color: #01031B;
        font-size: 1.2rem;
        width: 100%;
        height: auto;
    }
    p{  
        /* margin: 1rem 0rem; */
        /* padding: 0; */
        margin: 0;
        font-size: 1.5rem;
        color: #e21f36;
    }
    button{
        /* width: 5rem; */
        font-family: "Inter", sans-serif;
        font-weight: bold;
        font-size: 0.8rem;
        cursor: pointer;
        padding: 0.5rem 0.5rem;
        margin: 1rem 0rem 0rem 0rem;
        border: none;
        transition: all 0.5s ease;
        box-shadow: 0 0.25rem 0.5rem rgba(255, 255, 255, 0.4) inset;
        /* background: #E21F36; */
        background: orangered;
        color: white;
        &:hover{
            opacity: 0.9;
        }
    }
    @media screen and (max-width:900px){
        h4{
            font-size: 1rem;
        }
    }
`